<!-- LAYOUT TAILADMIN STYLE -->
<div class="flex h-screen overflow-hidden bg-brand-bg">

  <!-- SIDEBAR -->
  <app-sidebar></app-sidebar>

  <!-- CONTENT AREA -->
  <div class="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden transition-all duration-300"
    [ngClass]="menuService.showSideBar ? 'lg:ml-[260px]' : 'lg:ml-[80px]'">

    <!-- NAVBAR / HEADER -->
    <app-navbar></app-navbar>

    <!-- MAIN CONTENT -->
    <main class="mx-auto w-full max-w-screen-2xl max-h-screen py-4 md:p-6 2xl:p-10 pb-[100px]">
      <div [@routeAnimations]="prepareRoute(outlet)">
        <router-outlet #outlet="outlet"></router-outlet>
      </div>
      <app-scroll-to-top></app-scroll-to-top>
    </main>

  </div>

</div>